import InputGroupContent from '@/components/elements/input'
import { Box, Flex, Heading } from '@chakra-ui/react'
import Submit from '@/components/elements/submit'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import Toast from '@/components/elements/toast'
import { useState } from 'react'
import SpinnerLoading from '@/components/elements/spinner'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '@/store/store'
import { couponsSchema } from '@/entities/schemas/coupons'
import { createCoupon } from '@/services/api/coupons/coupons'
import { addCouponFn } from '@/store/features/coupons'
import {
	couponRefrestUpdate,
	sessionRefrestUpdate,
} from '@/store/features/state'
import { InferType } from 'yup'
import Select, { SelectOption } from '@/components/elements/select'
import { couponTypesOptions } from '@/utils/maps/coupon.types-map'
import CouponsEntity, { TypesCoupon } from '@/entities/api/coupons/coupons'
import { useFormErrorToast } from '@/hooks/useFormErrorToast'

type UserFormValues = InferType<typeof couponsSchema>

const AddCoupon = ({ close }: { close: () => void }) => {
	const token = useSelector((state: RootState) => state.auth.token)
	const {
		register,
		handleSubmit,
		control,
		formState: { errors },
	} = useForm<UserFormValues>({
		resolver: yupResolver(couponsSchema),
	})
	useFormErrorToast(errors)
	const [isLoading, setIsLoading] = useState<boolean>(false)
	const [type, setType] = useState<SelectOption | null>(null)
	const dispatch = useDispatch<AppDispatch>()
	const [selectPrice, setSelectPrice] = useState<number | number>(0)

	const onSubmit = async (dataYup: UserFormValues) => {
		try {
			setIsLoading(true)

			const data: Partial<CouponsEntity> = {
				expiration: dataYup.expiration,
				type: dataYup.type,
			}

			if (dataYup.type === TypesCoupon.AMOUNT) {
				console.log(selectPrice)
				if (!selectPrice) {
					Toast({ type: 'info', message: 'El monto es requerido' })
					setIsLoading(false)
					return
				}

				data.amount = selectPrice
			}

			if (dataYup.type === TypesCoupon.DISCOUNT) {
				if (!dataYup.discount) {
					Toast({ type: 'info', message: 'El descuento es requerido' })
					setIsLoading(false)
					return
				}
				data.discount = dataYup.discount
			}

			const response = await createCoupon(token ?? '', data)

			if (response?.status === 500 || response?.status === 409) {
				Toast({ type: 'error', message: 'Hubo un error al crear el cupon' })
				return
			}

			if (response?.status === 401) {
				dispatch(sessionRefrestUpdate())
				return
			}

			dispatch(addCouponFn(response?.data?.data))
			Toast({ type: 'success', message: 'Se creo correctamente' })
			dispatch(couponRefrestUpdate())
			setSelectPrice(0)
			setIsLoading(false)
			close()
		} catch (error) {
			Toast({ type: 'error', message: 'Algo salió mal al crear la categoría' })
			setIsLoading(false)
		}
	}

	return (
		<form onSubmit={handleSubmit(onSubmit)}>
			<Flex w='100%' h='full' flexDirection='column' alignItems='center'>
				<Box
					w='full'
					display='flex'
					justifyContent='start'
					alignItems='center'
					mb='2'
				>
					<Heading
						as='h4'
						fontSize={{ base: 'lg', md: 'xl' }}
						color='black'
						fontWeight='900'
					>
						Información general
					</Heading>
				</Box>
				<Select
					name='type'
					label='Tipo del producto'
					selectValue={setType}
					placeholder='Selecciona el tipo o entidad del producto'
					options={couponTypesOptions}
					control={control}
					isRequired={true}
				/>
				{type?.value === TypesCoupon.AMOUNT && (
					<InputGroupContent
						label='Monto en pesos (CO)'
						placeholder='Ingresa el monto'
						required
						isPrice={true}
						change={(e: React.ChangeEvent<HTMLInputElement>) => {
							setSelectPrice(Number(e.target.value) || 0)
						}}
					/>
				)}
				{type?.value === TypesCoupon.DISCOUNT && (
					<InputGroupContent
						label='Descuento en porcentaje (%)'
						placeholder='Ingresa el descuento'
						name='discount'
						required
						type='text'
						register={register}
						errors={errors}
					/>
				)}
				<InputGroupContent
					label='Fecha de vencimiento del cupon'
					name='expiration'
					type='datetime-local'
					register={register}
					errors={errors}
				/>
				<Box pt='4' pb='8'>
					{isLoading ? <SpinnerLoading /> : <Submit text='Agregar categoría' />}
				</Box>
			</Flex>
		</form>
	)
}

export default AddCoupon
